import { useState } from 'react';
import { FiHome, FiAlertTriangle } from 'react-icons/fi';
import Badge from '../../components/ui/Badge';
import Card from '../../components/ui/Card';
import SectionCard, { SectionCardList, SectionCardEmpty } from '../../components/ui/SectionCard';
import StatTile from '../../components/ui/StatTile';
import Tabs from '../../components/ui/Tabs';
import Table from '../../components/ui/Table';
import ComplianceRing from '../../components/ui/ComplianceRing';
import { Category, Section, Row } from './galleryPrimitives';

const COLUMNS = [
  { key: 'asset', label: 'Asset', sortable: true },
  { key: 'site', label: 'Site' },
  { key: 'result', label: 'Result', render: (r) => <Badge variant={r.tone}>{r.result}</Badge> },
];

const ROWS = [
  { id: 1, asset: 'RCD-014', site: 'Tweed Depot', result: 'PASS', tone: 'success' },
  { id: 2, asset: 'EXIT-207', site: 'Kingscliff Clinic', result: 'FAIL', tone: 'danger' },
];

const rowStyle = { padding: '0.75rem 0', color: 'var(--text-secondary)', fontSize: 'var(--text-sm)' };

/** Data display — badges, cards, stats, tabs, tables, and the compliance ring. */
export default function DataDisplayGallery() {
  const [tab, setTab] = useState('rcd');

  return (
    <Category id="data-display" title="Data display">
      <Section name="Badge" file="components/ui/Badge.jsx">
        <Row label="variant">
          <Badge variant="success">Compliant</Badge>
          <Badge variant="danger">Failed</Badge>
          <Badge variant="warning">Repairs due</Badge>
          <Badge variant="accent">Pending</Badge>
          <Badge variant="muted">Draft</Badge>
        </Row>
      </Section>

      <Section name="Card" file="components/ui/Card.jsx">
        <div style={{ display: 'grid', gap: '0.75rem', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))' }}>
          <Card>Card — no status</Card>
          <Card status="success">Card status=&quot;success&quot;</Card>
          <Card status="danger">Card status=&quot;danger&quot;</Card>
          <Card status="warning">Card status=&quot;warning&quot;</Card>
        </div>
      </Section>

      <Section name="SectionCard" file="components/ui/SectionCard.jsx">
        <div style={{ display: 'grid', gap: '0.75rem', gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))' }}>
          <SectionCard number="02" title="Active Sessions">
            <SectionCardList>
              <li style={rowStyle}>Banora Point High School</li>
              <li style={rowStyle}>Kingscliff Clinic</li>
            </SectionCardList>
          </SectionCard>
          <SectionCard number="03" title="Repairs Required">
            <SectionCardEmpty>No repairs outstanding.</SectionCardEmpty>
          </SectionCard>
          <SectionCard title="No number (eyebrow omitted)">
            <SectionCardList>
              <li style={rowStyle}>Row one</li>
              <li style={rowStyle}>Row two</li>
            </SectionCardList>
          </SectionCard>
        </div>
      </Section>

      <Section name="StatTile" file="components/ui/StatTile.jsx">
        <div style={{ display: 'grid', gap: '0.75rem', gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))' }}>
          <StatTile value="128" label="Assets" />
          <StatTile value="96%" label="Compliant" tone="success" />
          <StatTile value="7" label="Due soon" tone="warning" />
          <StatTile value="3" label="Overdue" tone="danger" />
          <StatTile value="12" label="Repairs" tone="brand" />
          <StatTile layout="row" icon={<FiHome />} value="4" label="Sites" />
          <StatTile layout="row" icon={<FiAlertTriangle />} value="2" label="Defects" tone="danger" />
        </div>
      </Section>

      <Section name="Tabs" file="components/ui/Tabs.jsx">
        <Tabs
          activeKey={tab}
          onChange={setTab}
          tabs={[
            { key: 'rcd', label: 'RCDs' },
            { key: 'exit', label: 'Exit Lights' },
            { key: 'db', label: 'Switchboards' },
          ]}
        />
      </Section>

      <Section name="Table" file="components/ui/Table.jsx">
        <Table columns={COLUMNS} data={ROWS} sortKey="asset" sortDir="asc" onSort={() => {}} />
      </Section>

      <Section name="ComplianceRing" file="components/ui/ComplianceRing.jsx">
        <div style={{ display: 'flex', gap: '2rem', flexWrap: 'wrap', alignItems: 'center' }}>
          <ComplianceRing percent={92} />
          <ComplianceRing percent={78} />
          <ComplianceRing percent={55} />
          <ComplianceRing percent={71} size="sm" />
          <ComplianceRing percent={null} size="sm" />
          <ComplianceRing percent={40} value={42} label="Due this month" />
        </div>
      </Section>
    </Category>
  );
}
